// extracted by mini-css-extract-plugin
export default {"IconHeading":"iconHeading_IconHeading__DudvT","Background":"iconHeading_Background__TX4uq"};